/** @warning should be used only within in the feature-flag package */

import { getFeatureFlagOverrides } from "./FlagReader";

const windowFF = window as unknown as {
  ff: { [key: string]: unknown };
};

export const getGlobalFeatureFlags = () => windowFF.ff;

export const updateGlobalConfig = (config: { [key: string]: unknown }) => {
  windowFF.ff = config;
};

export const addSessionStorageFeatureFlags = () => {
  const featureFlagOverrides = getFeatureFlagOverrides();

  featureFlagOverrides.forEach((flag) => {
    windowFF.ff = {
      ...windowFF.ff,
      [flag.name]: flag.value,
    };
  });
};
